export default __webpack_public_path__ + "static/media/quartz_crystal.40c2380f.png";